module.exports = __webpack_public_path__ + "img/dashboard_icon.3281bcaf.svg";